<div class="nova__dialog__toolbar">
    <div class="nova__dialog__toolbar__title">
        <span>Create new ticket</span>
    </div>
    <div class="nova__dialog__toolbar__controls">
        <button class="nova__button--icon" mat-dialog-close>
            <mat-icon class="nova-toolbar__controls__icon--close">close</mat-icon>
        </button>
    </div>
</div>
<div mat-dialog-content class="nova__dialog__content flex-col">
    <form [formGroup]="employeeSearchForm">
        <div>
            @if (hasSubcontractorPermission) {
            <mat-checkbox matInput formControlName="includeSubContr" class="inline">
                Include Subcontractors
            </mat-checkbox>
            }
        </div>
        <div class="flex-row">
            <mat-form-field appearance="outline" class="flex-100">
                <mat-label>Select Worker</mat-label>
                <input id="workerInput" matInput type="text" placeholder="Select worker" formControlName="searchName"
                    [matAutocomplete]="auto" [readonly]="preventChanges">
                <mat-autocomplete #auto="matAutocomplete" [displayWith]="candidateDisplay"
                    (optionSelected)="candidateSelected($event)">
                    @for (employee of candidates$ | async; track employee) {
                    <mat-option [value]="employee">
                        {{ employee?.name }}
                    </mat-option>
                    }
                </mat-autocomplete>
            </mat-form-field>
        </div>
        <div class="flex-row">
            <mat-form-field appearance="outline" class="flex-100">
                <mat-label>Select contract</mat-label>
                <mat-select data-qa-id="an_ct_contract_select" id="contractSelect" formControlName="selectedContract"
                    placeholder="Select contract">
                    @for (contr of ticketContracts$ | async; track contr) {
                    <mat-option [value]="contr">
                        <span>
                            {{contr?.callForJobs === 1 ? 'Aya MSP - ' : ''}}{{contr?.facilityName}}
                            - {{contr?.startDate | date:"M/d/yyyy"}}
                            - {{contr?.endDate | date:"M/d/yyyy"}} ({{contr?.status}})
                        </span>
                    </mat-option>
                    }
                </mat-select>
            </mat-form-field>
        </div>
    </form>
    <div [formGroup]="ticketForm" class="categories-menu">
        @for (frame of getCategories().controls; track frame; let i = $index) {
        <div [formArrayName]="'categories'">
            <form [formGroup]="frame | formGroup">
                <div class="row-item flex-row">
                    <div class="text-name flex-10" [matMenuTriggerFor]="categories" mat-button>
                        {{ getCategory(i)?.name }} => {{ getSubCategory(i)?.name }}
                    </div>
                    <div class="flex-row flex-87">
                        <div class="flex-100">
                            <label>Add Note</label>
                            <nova-rich-editor data-qa-id="an_ct_note_textarea" formControlName="categoryNote"
                                class="inline text-editor" [maxlength]="5000" [useIframe]="false">
                            </nova-rich-editor>
                        </div>
                        @if (getSubCategory(i)?.id === bookedDaysSubcategoryId) {
                        <div class="category-input-item flex-100">
                            <label>Add Booked Days</label>
                            <nova-rich-editor data-qa-id="an_ct_note_textarea" formControlName="bookedDays"
                                class="inline text-editor" [maxlength]="5000" [useIframe]="false">
                            </nova-rich-editor>
                        </div>
                        }
                    </div>
                    @if (getCategory(i)?.name === 'License') {
                    <mat-form-field appearance="outline" class="category-input-item">
                        <mat-select placeholder="Select a state" formControlName="stateId">
                            @for (state of states$ | async; track state) {
                            <mat-option [value]="state?.id">
                                {{ state?.name }} - ({{ state?.code }})
                            </mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                    }
                    <div class="cancel-action-column flex-3">
                        <mat-icon (click)="removeItem(i)">close</mat-icon>
                    </div>
                </div>
                <mat-menu [overlapTrigger]="false" #categories="matMenu">
                    @for (category of ticketCategories; track category) {
                    <div>
                        @if (!category?.parentCategoryId) {
                        <button (click)="selectCategory(category.id, i)" (menuOpened)="setActive(category.id)"
                            mat-menu-item class="action-button" [matMenuTriggerFor]="subcategory">
                            @if (category.id === frame?.value?.categoryId) {
                            <mat-icon class="done">done
                            </mat-icon>
                            }
                            <span>{{category?.name}}</span>
                        </button>
                        }
                    </div>
                    }
                </mat-menu>
                <mat-menu #subcategory="matMenu">
                    @for (subCategory of ticketCategories; track subCategory) {
                    <div>
                        @if (subCategory?.parentCategoryId === subListCategoryId) {
                        <button (click)="selectSubCategory(subCategory.id, i)" class="action-button" mat-menu-item>
                            @if (subCategory.id === frame?.value?.subCategoryId) {
                            <mat-icon class="done">
                                done
                            </mat-icon>
                            }
                            <span>{{subCategory?.name}}</span>
                        </button>
                        }
                    </div>
                    }
                </mat-menu>
            </form>
        </div>
        }
        <div>
            <button data-qa-id="an_ct_category_button" [disabled]="!employeeSearchForm.valid"
                [matMenuTriggerFor]="categoriesCreate" mat-flat-button color="primary">
                SELECT CATEGORY
            </button>
            <mat-menu [overlapTrigger]="false" #categoriesCreate="matMenu">
                @for (category of ticketCategories; track category) {
                <div>
                    @if (!category?.parentCategoryId) {
                    <button (menuOpened)="setActive(category.id)" mat-menu-item class="action-button"
                        [matMenuTriggerFor]="subcategory">
                        <span>{{category?.name}}</span>
                    </button>
                    }
                </div>
                }
            </mat-menu>
            <mat-menu #subcategory="matMenu">
                @for (subCategory of ticketCategories; track subCategory) {
                <div>
                    @if (subCategory?.parentCategoryId === subListCategoryId) {
                    <button (click)="createSubCategory(subCategory.id)" class="action-button" mat-menu-item>
                        <span>{{subCategory?.name}}</span>
                    </button>
                    }
                </div>
                }
            </mat-menu>
        </div>
    </div>
    <mat-dialog-actions class="nova__dialog__content__actions action-button-offset">
        <button [disabled]="!ticketForm.value.categories.length || employeeSearchForm.invalid" (click)="createTicket()"
            mat-flat-button data-qa-id="an_ct_save_button" color="primary">
            SAVE
        </button>
        <button color="cancel" (click)="close()" data-qa-id="an_ct_cancel_button" mat-flat-button>
            CANCEL
        </button>
    </mat-dialog-actions>
</div>